import React from "react"
import Layout from "../components/layout/layout"
import Book from "../components/book/book"

const WalkIn = props => {
  const params = new URLSearchParams(props.location.search)
  const barber = params.get("barber")

  const postURL =
    "https://appointment-system.onrender.com/api/walkinAppointment"

  return (
    <Layout hideBookBtn>
      <Book walkin barber={barber} postURL={postURL} />
    </Layout>
  )
}

export default WalkIn
